import { useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

const ContactsScreen = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Intégrer l'envoi à un backend ici
  };
  
  return (
    <Container>
      <div className="h1-container">
        <h1>Nous contacter</h1>
      </div>
      {/* <Row>
        <Col md={6} className="px-4"> */}
          <div className="emailButton"><a href="mailto:contact@groupe-cei.com">contact@groupe-cei.com</a></div>
          <div className="bg-light p-0 rounded mb-4">
            <h2>Nous soumettre votre manuscrit</h2>
            <p>Nous n’acceptons en comité de lecture ni romans, ni nouvelles, ni sujets de société. Le comité ne reçoit que les textes poétiques</p>
            <p>Le texte devra être pourvu d’un titre</p>
            <p>Le volume devra avoir une densité suffisante pour faire 60 pages au moins et 120 pages au plus</p>
            <p>Ne seront étudiés que les textes envoyés sous word</p>
            <p>Un saut de page entre chaque poème sera exigé (onglet insertion / saut de page) les sauts de ligne successifs pour passer à la page suivante étant incompatibles avec une bonne mise en page.</p>
            <p>Le texte sera référencé dès sa réception puis anonymé. Aucun membre du comité de lecture ne connaîtra l’origine du texte</p>
            <p>Un document pdf sera créé avec la mention en filigrane “droits réservés” puis circulera auprès d’un groupe de 5 à 8 personnes</p>
            <p>Le document word sera détruit</p>
            <p>Il ne sera pas possible de fixer une date de réponse, chaque membre du comité pouvant avoir ses propres impératifs</p>
            <p>Nous ne retenons que trois à quatre manuscrits par an. Veuillez ne pas nous tenir rigueur si nous ne retenons pas votre recueil, car notre structure n’est pas en mesure de faire davantage.</p>
            <p>Le texte sera référencé dès sa réception puis anonymé...</p>
            <p><b>Nous vous remercions de votre bienveillance et de votre confiance.</b></p>
            <p><em>La Direction</em></p>
          </div>
        {/* </Col> */}
        {/* <Col md={6} className="px-4">
          <h3>Nous poser une question</h3>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Control type="text" name="name" placeholder="Votre nom et prénom *" required value={formData.name} onChange={handleChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control type="email" name="email" placeholder="Votre adresse e-mail *" required value={formData.email} onChange={handleChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control type="tel" name="phone" placeholder="Votre numéro de téléphone mobile" value={formData.phone} onChange={handleChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control as="textarea" name="message" placeholder="Votre message *" required rows={4} value={formData.message} onChange={handleChange} />
            </Form.Group>
            <Button type="submit" variant="primary" className="w-100">Envoyer</Button>
          </Form>
          <div className="mt-3">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2845.6472893949885!2d0.16861407678556697!3d44.50189349712773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12aa8f12662af6f1%3A0xeee36392a658e3f1!2s7%20Av.%20de%20Lattre%20de%20Tassigny%2C%2047200%20Marmande!5e0!3m2!1sfr!2sfr!4v1743063435683!5m2!1sfr!2sfr" 
              width="100%" height="400px"
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </Col> */}
      {/* </Row> */}
      
      {/* Section "S'inscrire à la Newsletter" */}
      <div className="bg-light p-4 rounded text-center">
        <h3>S'inscrire à la Newsletter</h3>
        <p>Recevez nos actualités directement dans votre boîte mail.</p>
        <Form className="d-flex justify-content-center">
          <Form.Control type="email" placeholder="Votre adresse e-mail" required className="w-auto me-2" />
          <Button type="submit" variant="primary">S'inscrire</Button>
        </Form>
        <p className="text-muted mt-2">Nous respectons votre vie privée. Vous pouvez vous désinscrire à tout moment.</p>
      </div>
    </Container>
  );
};

export default ContactsScreen;
